import { CardNotAvailableImage } from 'components/cards/components/cardNotAvailableImage';
import { DynamicImage } from 'components/Image';
import { ImageProps } from 'next/image';
import React from 'react';
import { isNotEmpty } from 'utility/functions';
import styles from './GameDetailSkillGamesCard.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';

export type GameDetailSkillGamesCardProps = {
  coverImage: ImageProps;
  isNew: boolean;
  isExclusive: boolean;
};
export const GameDetailSkillGamesCard = ({ coverImage, isNew, isExclusive }: GameDetailSkillGamesCardProps) => {
  const labelNew = useGetLabelByKey('new-slot');
  const labelExclusive = useGetLabelByKey('in-esclusiva');
  return (
    <React.Fragment>
      {isNotEmpty(coverImage?.src) ? (
        <DynamicImage
          src={coverImage?.src ?? ''}
          alt={coverImage?.alt ?? ''}
          fill
          loading="lazy"
          decoding="async"
          className={styles.image}
        />
      ) : (
        <CardNotAvailableImage />
      )}
      {isNew && <div className={styles.new}>{labelNew!}</div>}
      {isExclusive && <div className={styles.exclusive}>{labelExclusive!}</div>}
    </React.Fragment>
  );
};
